<template>
  <Modal v-model="showModal" width="md">
    <div slot="header">
      Exportar Documentos
    </div>

    <div>
      <p class="mb-3">
        <strong>{{ selectedCount }}</strong> {{ selectedCount === 1 ? 'multa selecionada' : 'multas selecionadas' }}
      </p>

      <div class="form-group">
        <label>Selecione os tipos de documentos para exportar:</label>

        <div class="document-options mt-3">
          <div v-for="doc in documentTypes" :key="doc.value" class="form-check mb-2">
            <input class="form-check-input" type="checkbox" :id="`doc-${doc.value}`" :value="doc.value"
              v-model="selectedDocuments">
            <label class="form-check-label" :for="`doc-${doc.value}`">
              {{ doc.label }}
            </label>
          </div>
        </div>
      </div>

      <DocumentExportChoices
        :scope.sync="scope"
        :folder-mode.sync="folderMode"
        :count="count"
        :notice="notice"
        :loading="loadingCount"
        :has-types="hasTypes"
        :disabled="isExporting"
      />
    </div>

    <div slot="footer">
      <button v-if="isExporting" class="btn btn-outline-red mr-2" @click="abortExport">Cancelar</button>
      <button v-else class="btn btn-outline mr-2" @click="cancel">Cancelar</button>
      <button class="btn btn-primary" @click="exportDocuments"
        :disabled="!hasTypes || overLimit || isExporting">
        {{ isExporting ? 'Exportando...' : 'Exportar' }}
      </button>
    </div>
  </Modal>
</template>

<script>
import DocumentExportChoices from '@/components/shares/DocumentExportChoices'
import DocumentExporter from '@/mixins/DocumentExporter'
import Modal from '@/components/shares/specialTag/Modal'

export default {
  name: 'DocumentExporterModal',
  components: {
    DocumentExportChoices, Modal
  },
  computed: {
    documentTypes() {
      return [
        { value: 'boleto', label: 'Boleto' },
        { value: 'fici', label: 'FICI' },
        { value: 'notification', label: 'Notificação' },
        { value: 'demonstrativo', label: 'Demonstrativo' }
      ].filter(doc => this.$canDownloadKind('cm-frotas', doc.value))
    }
  },
  methods: {
    requestCount(query, types, cancelToken) {
      return this.axios.get('maestro/tickets/documents_count', {
        params: { q: { ...query, kind: types } },
        cancelToken
      })
    },
    requestExport(query, types, cancelToken) {
      return this.axios.get('maestro/tickets/latest_documents', {
        params: {
          q: { ...query, kind: types },
          document_scope: this.scope,
          folder_mode: this.folderMode
        },
        cancelToken
      })
    }
  },
  mixins: [DocumentExporter]
}
</script>

<style scoped></style>
